import React, { useEffect, useState } from 'react';
import CheckboxTree from 'react-checkbox-tree';
import { FormattedMessage, WrappedComponentProps, useIntl } from 'react-intl';
import { IAccountBillTo } from '../../../models/account';
import '../../inputs/select-input.css';
import { IUserLocation } from '../../../models/user-model';
import { isMiracleEar } from '../../../hooks/miracle-ear-hook';
import { ISession } from '../../../models/pro-sites';
interface IUserAccountsTreeProps {
    name: string;
    companyAccounts: IAccountBillTo[];
    userAccounts: IUserLocation[];
    onChange: (event: any) => void;
    session: ISession;
}

const UserAccountsTree = ({
    name = 'accounts',
    companyAccounts,
    userAccounts,
    onChange,
    session,
}: IUserAccountsTreeProps) => {
    const intl = useIntl();
    const [checkedLocations, setCheckedLocations] = useState<string[]>([]);
    const [expanded, setExpanded] = useState<string[]>([]);
    const [nodes, setNodes] = useState<any[]>([]);
    const [searchString, setSearchString] = useState<string>('');
    const [cfcrError, setCfCrError] = useState(false);
    const regexPattern = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?@()._]/g;
    const search = () => {
        if (!searchString) return;
        const upperSearch = searchString.toUpperCase();
        const chk: string[] = checkedLocations;
        let matched: string[] = [];
        nodes.forEach((n) => {
            if (n.children) {
                n.children.forEach((c: any) => {
                    if (c.account) {
                        if (c.account.includes(upperSearch)) {
                            chk.push(c.value);
                            matched.push(c.value);
                        }
                    }
                });
            }
        });
        if (!matched.length) {
            setCfCrError(true);
        } else {
            handleChecked(chk);
        }
        matched = [];
    };
    const handleSearchChange = (e: any) => {
        setSearchString(e.target.value);
    };

    const handleSearch = () => {
        if (regexPattern.test(searchString)) {
            setCfCrError(true);
        } else {
            setCfCrError(false);
            search();
        }
    };
    useEffect(() => {
        const exn: string[] = [];
        const chk: string[] = [];

        if (!userAccounts) {
            return;
        }

        const accounts = companyAccounts.map((a, i) => {
            exn.push(i.toString());

            const selectAll = userAccounts.find(
                (x) =>
                    x.billTo === a.fullAccountNumber &&
                    x.shipTo === null &&
                    x.location === null
            );

            const node = {
                value: i,
                label: (
                    <span>
                        {a.fullAccountNumber} : {a.partyName}
                    </span>
                ),
                children: a.shipToAccounts.map((s, j) => {
                    const child = {
                        value: i + '|' + j,
                        account: s.fullAccountNumber,
                        label: (
                            <>
                                <span>
                                    {s.fullAccountNumber} : {s.partyName}
                                </span>
                                <br />
                                <span
                                    style={{
                                        fontSize: '10px',
                                        marginLeft: '30px',
                                    }}
                                >
                                    {s.street1}
                                </span>
                                <br />
                                <span
                                    style={{
                                        fontSize: '10px',
                                        marginLeft: '30px',
                                    }}
                                >
                                    {s.city},&nbsp;{s.state}&nbsp;{s.postalCode}
                                </span>
                            </>
                        ),
                    };

                    if (selectAll) {
                        chk.push(child.value);
                    } else if (
                        userAccounts.find(
                            (x) =>
                                x.billTo === a.fullAccountNumber &&
                                x.shipTo === s.accountNumber &&
                                x.location === s.location
                        )
                    ) {
                        chk.push(child.value);
                    }

                    return child;
                }),
            };

            return node;
        });

        setExpanded(exn);
        setCheckedLocations(chk);
        setNodes(accounts);
    }, [companyAccounts, userAccounts]);

    const selectAll = () => {
        const chk: string[] = [];
        nodes.forEach((n) => {
            if (n.children) {
                n.children.forEach((c: { value: string }) => {
                    chk.push(c.value);
                });
            }
        });
        handleChecked(chk);
    };

    const deSelectAll = () => {
        setCheckedLocations([]);
        handleChecked([]);
    };

    const handleChecked = (selected: string[]) => {
        const mapped: any[] = [];
        const selectedLocations: IUserLocation[] = [];

        selected.forEach((c) => {
            const x = c.split('|');
            const bt = +x[0];
            const st = +x[1];

            let found = mapped.find((x) => x.bt === bt);

            if (!found) {
                found = { bt, st: [] };
                mapped.push(found);
            }

            found.st.push(st);
        });

        mapped.forEach((a: any) => {
            const billTo = companyAccounts[a.bt];

            if (a.st.length === billTo.shipToAccounts.length) {
                selectedLocations.push({
                    billTo: billTo.fullAccountNumber,
                    shipTo: null,
                    location: null,
                });
            } else {
                a.st.forEach((sta: number) => {
                    const shipTo = billTo.shipToAccounts[sta];
                    selectedLocations.push({
                        billTo: billTo.fullAccountNumber,
                        shipTo: shipTo.accountNumber,
                        location: shipTo.location,
                    });
                });
            }
        });

        const target = { name: name, value: selectedLocations };
        onChange({ target });
    };

    return (
        <>
            <div>
                <button
                    type="button"
                    id="checkalllocations"
                    className="btn btn-default"
                    style={{ marginLeft: '12px' }}
                    onClick={selectAll}
                >
                    <FormattedMessage
                        id="Check_All_Locations"
                        defaultMessage="Check All Locations"
                    />
                </button>
                <button
                    type="button"
                    id="uncheckalllocations"
                    className="btn btn-default"
                    onClick={deSelectAll}
                >
                    <FormattedMessage
                        id="Uncheck_All_Locations"
                        defaultMessage="Uncheck All Locations"
                    />
                </button>
                <p />
            </div>
            {isMiracleEar(session.siteNumber) && (
                <div className="row">
                    <div className="control-label col-sm-4">
                        <label>
                            <FormattedMessage
                                id="CF/CR Group: "
                                defaultMessage="CF/CR Group: "
                            />
                        </label>
                    </div>

                    <div className="col-md-8">
                        <div className="input-group">
                            <input
                                type="text"
                                name="searchString"
                                className="form-control"
                                placeholder={intl.formatMessage({
                                    id: 'Enter Filter',
                                    defaultMessage: 'Enter Filter',
                                })}
                                value={searchString}
                                onChange={handleSearchChange}
                                maxLength={10}
                            />
                            <span className="input-group-addon">
                                <button
                                    className="button-label button-add-on"
                                    type="button"
                                    title="Search"
                                    onClick={handleSearch}
                                >
                                    <FormattedMessage
                                        id="Update"
                                        defaultMessage="Update"
                                    />
                                </button>
                            </span>
                        </div>
                        {cfcrError && (
                            <div
                                className="alert alert-danger"
                                style={{ margin: 0 }}
                            >
                                <FormattedMessage
                                    id="Invalid CF/CR Group. Please verify and try again"
                                    defaultMessage="Invalid CF/CR Group. Please verify and try again"
                                />
                            </div>
                        )}
                    </div>
                    <div className="CFCR">
                        <FormattedMessage
                            id="*Clicking update will check the CF/CR Group accounts."
                            defaultMessage="*Clicking update will check the CF/CR Group accounts."
                        />
                    </div>
                </div>
            )}
            <CheckboxTree
                nodes={nodes}
                expanded={expanded}
                checked={checkedLocations}
                onCheck={handleChecked}
                onExpand={() => {}}
            />
        </>
    );
};

export default UserAccountsTree;
